import Component from '../../lib/component'
import { RootComponent } from '../../main'

export default class ClientHandbookIndexComponent extends Component {
    static selector () {
        return '.client-handbook-index'
    }

    constructor (opts) {
        super(opts)

        this.render()
        this.onScroll()
        this.listen()
    }

    listen () {
        this.on('resize', (e) => {
            this.render()
            this.onScroll()
        })

        this.getNavAnchors()
            .forEach(el => {
                el.addEventListener('click', this.onNavAnchorClick.bind(this))
                el.addEventListener('keydown', this.onNavAnchorKeydown.bind(this))
            })

        if ((RootComponent.Scroller || {}).state)
            RootComponent.Scroller.state
                .on('update', this.onScroll.bind(this))

        RootComponent.Scroller
            .on('scrollingTo:complete', () =>
                this.setNavAnchorActive(this.forceActiveAnchor))
    }

    onNavAnchorClick (e) {
        this.forceActiveAnchor = e.target.nodeName === 'SPAN'
            ? e.target.offsetParent
            : e.target

        this.setNavAnchorActive(this.forceActiveAnchor)
    }

    onNavAnchorKeydown (e) {
        if (e.keyCode === 32
                || (e.keyIdentifier || e.key || '').match(/^(enter)$/i))
            return this.onNavAnchorClick(e)
    }

    onScroll (e = {
        data: {
            currentData: (RootComponent.Scroller || {}).state
                ? RootComponent.Scroller.state.get()
                : {}
        }
    }) {
        const nav = this.getNav()

        if (!nav
                || this.props.stickyDisabled
                || window.getComputedStyle(nav).display === 'none')
            return

        const bounds = nav.parentElement.getBoundingClientRect()

        const top = bounds.top

        const navListBounds = this.getNavList()
            ? this.getNavList().getBoundingClientRect()
            : { bottom: 0 }

        const elBounds = this.el.getBoundingClientRect()

        const elPadBottom = parseFloat(window
            .getComputedStyle(this.el)
            .paddingBottom || '0')

        const isBottom = elBounds.bottom - elPadBottom <= navListBounds.bottom

        if (top < 0 && !isBottom && !this.props.sticky) {
            this.props.sticky = true
            this.render()
        }
        else if ((top >= 0 || isBottom) && this.props.sticky) {
            this.el.removeAttribute('data-sticky')
            return this.render()
        }

        if (RootComponent.Scroller.scrollingTo)
            return

        if (this.forceActiveAnchor) {
            this.forceActiveAnchor = null
            return
        }

        // Update Active Nav Anchor
        const navAnchors = this.getNavAnchors()
            .filter(el => !el.getAttribute('aria-disabled'))

        const navAnchorsMap = navAnchors
            .map(el => ({
                el,
                id: el.getAttribute('href')
                    .replace(/(.+)(#.+)/, '$2')
            }))
            .map(obj => Object.assign(obj, {
                item: this.el.querySelector(obj.id)
            }))

        const isItemActive = (obj, idx) => {
            const itemBounds = obj.item.getBoundingClientRect()
            const itemTop = itemBounds.top - (window.innerHeight * 0.5)
            const itemBottom = itemBounds.bottom - (window.innerHeight * 0.5)

            return (itemTop <= 0 && itemBottom > 0)
                || (idx === 0 && itemTop > 0)
        }

        const activeIdx = this.getNavAnchorActive()
            ? navAnchors
                .indexOf(this.getNavAnchorActive())
            : -1

        if (activeIdx >= 0
                && isItemActive(navAnchorsMap[activeIdx], activeIdx))
            return

        console.groupCollapsed('Client Handbook Nav Anchors')

        navAnchorsMap
            .some((obj, idx) => {
                console.log(obj.item.id)

                if (!isItemActive(obj, idx))
                    return false

                return obj.el !== this.getNavAnchorActive()
                    ? this.setNavAnchorActive(obj.el)
                    : true
            })

        console.groupEnd()
    }

    getNav () {
        return this.el.querySelector('.client-handbook-index-articles nav')
    }

    getNavList () {
        const nav = this.getNav()

        return nav
            ? nav.querySelector('ul')
            : null
    }

    getNavHeight () {
        return this.getNavList()
            ? this.getNavList().clientHeight
            : 0
    }

    getNavAnchors () {
        return this.getNav()
            ? Array.from(this.getNav().querySelectorAll('li a'))
            : []
    }

    getNavAnchorActive () {
        return this.getNav()
            .querySelector('[aria-current="true"]')
    }

    setNavAnchorActive (node) {
        this.getNavAnchors()
            .forEach(el => el.setAttribute('aria-current', el === node))
    }

    getArticles () {
        return Array.from(this.el.querySelectorAll('article'))
    }

    render () {
        if (!this.getNavAnchors())
            return

        // Short viewport, disable sticky nav
        if (window.innerHeight < this.getNavHeight())
            this.props.stickyDisabled = true
        else if (this.props.stickyDisabled)
            this.el.removeAttribute('data-sticky-disabled')
    }
}
